import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KIconModule } from 'ng-k-icon';
import { KButtonModule } from 'ng-k-button';
import { EstablishBreachOfDutyComponent } from './establish-breach-of-duty.component';
import { KDataVisualizationModule } from 'ng-k-data-visualization';
import { NgChartsModule } from 'ng2-charts';
import { CustomBreadcrumbModule } from 'src/app/pages/common/custom-breadcrumb/custom-breadcrumb.module';

@NgModule({
  declarations: [
    EstablishBreachOfDutyComponent
  ],
  imports: [
    CommonModule,
    KIconModule,
    KButtonModule,
    KDataVisualizationModule,
    NgChartsModule,
    CustomBreadcrumbModule
  ]
})
export class EstablishBreachOfDutyModule { }
